import React, { useState } from 'react';
import { omit } from 'ramda';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import Alert from 'sharedComponents/Alert';
import useApp from 'reducers/hooks/useApp';

// import GoogleAuthButton from 'sharedComponents/GoogleAuthButton';
// import { getServerErrorsFullMessages } from 'utils/errors';

import BuyerRegistrationForm from 'sharedComponents/BuyerRegistrationForm';

import useStyles from './useStyles';

const BuyerRegistration = props => {
  const classes = useStyles();
  const { signUp, isSigningUp } = useApp();
  const { t } = useTranslation();
  const { onFinish } = props;

  const [alert, setAlert] = useState({ show: false, text: '', severity: '' });
  const handleCloseAlert = () => setAlert({ ...alert, show: false });

  const handleSubmit = async values => {
    const attrs = omit('passwordConfirmation', values);
    await signUp({ ...attrs, userType: 'buyer' });
    onFinish();
  };

  // const handleSignUpWithGoogle = async response => {
  //   const { credential } = response;

  //   try {
  //     await loginWithGoogle({ tokenId: credential, provider: 'google_oauth2' });
  //     onFinish();
  //   } catch (err) {
  //     const { fullErrorMessages } = getServerErrorsFullMessages(err);
  //     setAlert({ show: true, text: fullErrorMessages, severity: 'error' });
  //   }
  // };

  return (
    <Box className={classes.container} id="signUp">
      <Typography className={classes.header}>{t('components.NonAuthSurveyPage.BuyerRegistration.header')}</Typography>
      <BuyerRegistrationForm onSubmit={handleSubmit} isSigningUp={isSigningUp} buttonLabel="Request Quote" />
      {alert.show && <Alert text={alert.text} open severity={alert.severity} handleClose={handleCloseAlert} />}
      {/*      <div className={classes.divider}>
        <div className={classes.line} />
        <Typography variant="body1">{t('components.NonAuthSurveyPage.BuyerRegistration.or')}</Typography>
        <div className={classes.line} />
      </div>
      <div className={classes.socialBox}>
        <GoogleAuthButton onSuccess={handleSignUpWithGoogle} />
      </div> */}
    </Box>
  );
};

BuyerRegistration.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default BuyerRegistration;



// WEBPACK FOOTER //
// ./src/components/NonAuthSurveyPage/components/BuyerRegistration/BuyerRegistration.js